<div class="container">
    <img *ngFor="let current of [ 1, 2, 3, 4, 5]" [src]="getStarImage(current)" [ngStyle]="styles" alt="">
</div>
